import PropTypes from 'prop-types';
import React from 'react';
import { Header } from '../UI';

const TechnicalIssue = ({ children }) => (
  <Header size="5" fontWeight="300">{children}</Header>
);

TechnicalIssue.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TechnicalIssue;
